export const PAYMENT_FAILED_STATUS = "FAILED";
export const PAYMENT_PENDING_STATUS = "PENDING";
export const PAYMENT_VALIDATED_STATUS = "VALIDATED"
export const INEXIST_PAYMENT = "INEXIST_PAYMENT"
